import { motion } from "framer-motion";
import { Eyebrow, GoldRule, PrimaryLink, SecondaryLink } from "./Primitives";
import { RidgeLines } from "./Marks";
import { fadeInUp } from "../../lib/brand";

export const PageHero = ({ eyebrow, title, copy, children, testId }) => (
  <section data-testid={testId} className="relative pt-40 pb-20 md:pt-48 md:pb-28 bg-summit-bg overflow-hidden">
    <RidgeLines className="absolute inset-x-0 bottom-0 h-64 md:h-80 w-full opacity-70 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-10">
      <motion.div {...fadeInUp} className="max-w-4xl">
        {eyebrow && <Eyebrow className="mb-6">{eyebrow}</Eyebrow>}
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-summit-charcoal">
          {title}
        </h1>
        <GoldRule className="my-8" />
        {copy && <p className="font-body text-base md:text-lg text-summit-text-muted leading-relaxed max-w-2xl">{copy}</p>}
        {children}
      </motion.div>
    </div>
  </section>
);

export const CTASection = ({ eyebrow = "Next Step", heading, copy, primaryLabel = "Schedule a Strategy Conversation", secondary, testId = "cta-section" }) => (
  <section data-testid={testId} className="relative bg-summit-forest text-white py-24 md:py-32 overflow-hidden grain">
    <RidgeLines className="absolute inset-x-0 top-0 h-full w-full opacity-40 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
      <motion.div {...fadeInUp} className="lg:col-span-8">
        <Eyebrow light className="mb-6">{eyebrow}</Eyebrow>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight">{heading}</h2>
        {copy && <p className="mt-6 font-heading text-2xl md:text-3xl font-light text-summit-gold-light leading-snug max-w-2xl">{copy}</p>}
      </motion.div>
      <motion.div {...fadeInUp} transition={{ ...fadeInUp.transition, delay: 0.15 }} className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
        <PrimaryLink to="/contact" testId={`${testId}-primary-btn`} className="!bg-summit-gold hover:!bg-summit-gold-dark !text-summit-charcoal hover:!text-white">
          {primaryLabel}
        </PrimaryLink>
        {secondary && (
          <SecondaryLink to={secondary.to} light testId={`${testId}-secondary-btn`}>
            {secondary.label}
          </SecondaryLink>
        )}
      </motion.div>
    </div>
  </section>
);
